import { render, staticRenderFns } from "./SedesLinkedCompanies.vue?vue&type=template&id=e2b8e876&scoped=true"
import script from "./SedesLinkedCompanies.vue?vue&type=script&lang=js"
export * from "./SedesLinkedCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b8e876",
  null
  
)

export default component.exports